import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Chapter } from "../components/Chapter";
import { IMG } from "../lib/scenes";

// Complexity — there has to be a better way.
export const SceneComplexity = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgScale = useTransform(scrollYProgress, [0, 1], [1.08, 1]);

  return (
    <section
      id="complexity"
      data-scene
      ref={ref}
      className="relative px-6 py-14 md:px-12 md:py-24 lg:px-24"
    >
      <div className="mx-auto w-full max-w-[1600px]">
        <Chapter title="The problem" />

        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-5">
            <h2 className="font-display text-6xl font-black leading-[0.92] tracking-tighter text-[#1b1a18] sm:text-7xl">
              There has to be a better way.
            </h2>
            <p className="mt-6 max-w-md font-body text-xl leading-relaxed text-[#6b665e]">
              Notebooks, whiteboards and a dozen apps that never talk to each other.
            </p>
          </div>

          <div className="lg:col-span-7">
            <div className="overflow-hidden rounded-2xl">
              <motion.img
                src={IMG.complexity}
                alt="A busy kitchen during a full service"
                style={{ scale: imgScale }}
                className="aspect-[4/3] w-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
